import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common'
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {PickupPointFeeEditComponent} from "./edit/pickup-point-fee-edit.component";
import {PickupPointFeeListComponent} from "./list/pickup-point-fee-list.component";
import {PickupPointFeeRoutingModule} from "./pickup-point-fee-routing.module";
import {SharedModule} from "../../shared/shared.module";
import {PickupPointFeeCardContentComponent} from "./list/fee-card-content/pickup-point-fee-card-content.component";

@NgModule({
    imports: [CommonModule, FormsModule, ReactiveFormsModule, PickupPointFeeRoutingModule, TranslateModule,
        SharedModule],
    declarations: [
        PickupPointFeeListComponent,PickupPointFeeEditComponent, PickupPointFeeCardContentComponent
    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class PickupPointFeeModule {}


// WEBPACK FOOTER //
// ./public/upgrade/feature/pickuppointfee/pickup-point-fee.module.ts